import { Injectable, signal } from '@angular/core';

/**
 * Root singleton for dealer-level state shared across shell layout, header, and route guards.
 *
 * {@link setIsSfsPricingGroup} is written by HeaderComponent after dealer search;
 * {@link setDealerNavigationContextReady} gates module nav until JWT + dealer context settle (AOS-6119).
 */
@Injectable({ providedIn: 'root' })
export class DealerStateService {
  private readonly _isSfsPricingGroup = signal(false);
  private readonly _dealerNavigationContextReady = signal(false);

  /** True when the current dealer has `riskDealerPricingGroup === 'STE'`. */
  readonly isSfsPricingGroup = this._isSfsPricingGroup.asReadonly();

  /**
   * True when header navigation may render module tabs (JWT applied and dealer fetch finished when applicable).
   */
  readonly dealerNavigationContextReady = this._dealerNavigationContextReady.asReadonly();

  setIsSfsPricingGroup(value: boolean): void {
    this._isSfsPricingGroup.set(value);
  }

  setDealerNavigationContextReady(value: boolean): void {
    this._dealerNavigationContextReady.set(value);
  }
}
